"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teamsDarkTheme: function() {
        return _index.teamsDarkTheme;
    },
    teamsDarkV21Theme: function() {
        return _index.teamsDarkV21Theme;
    },
    teamsHighContrastTheme: function() {
        return _index.teamsHighContrastTheme;
    },
    teamsLightTheme: function() {
        return _index.teamsLightTheme;
    },
    teamsLightV21Theme: function() {
        return _index.teamsLightV21Theme;
    },
    webDarkTheme: function() {
        return _index1.webDarkTheme;
    },
    webLightTheme: function() {
        return _index1.webLightTheme;
    }
});
const _index = require("./teams/index.js");
const _index1 = require("./web/index.js");
